import "@hotwired/turbo-rails";

import "./controllers";

// Chromium's native <select> popup can drift out of place instead of staying
// anchored while the page scrolls; blurring closes it immediately so it never
// looks detached. Capture phase catches scrolling on any container, not just window.
document.addEventListener(
  "scroll",
  () => {
    if (document.activeElement instanceof HTMLSelectElement) {
      document.activeElement.blur();
    }
  },
  { capture: true, passive: true },
);
